"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
const spacing = 5;
var _default = exports.default = spacing;
